import { v4 as uuid } from 'uuid';
import umlCanvasEngine from '../../Core/UmlCanvasEngine';
import { getStrategyKeyForFilename } from '../../Core/Import/ImportStrategyRegistry';

const STAGGER_OFFSET = 24;
const BASE_X = 80;
const BASE_Y = 80;

/**
 * Next staggered drop position for a newly imported shape, based on current
 * shape count on canvas.
 * @returns {{x: number, y: number}}
 */
export function nextPosition() {
    const n = umlCanvasEngine.shapes.length;
    return { x: BASE_X + (n % 8) * STAGGER_OFFSET, y: BASE_Y + (n % 8) * STAGGER_OFFSET };
}

/**
 * Builds file-list entries from a dropped/selected FileList, tagging each
 * with the strategy key its extension maps to (ImportStrategyRegistry) —
 * null strategyKey means unsupported.
 * @param {FileList} fileList
 * @returns {{id: string, file: File, name: string, strategyKey: string|null, status: 'pending'|'unsupported'|'parsed'}[]}
 */
export function toFileEntries(fileList) {
    return Array.from(fileList).map(function toEntry(file) {
        const strategyKey = getStrategyKeyForFilename(file.name);
        return { id: uuid(), file, name: file.name, strategyKey, status: strategyKey ? 'pending' : 'unsupported' };
    });
}

/**
 * @param {object[]} droppedFiles
 * @returns {string}
 */
export function summarizeStatus(droppedFiles) {
    if (droppedFiles.length === 0) return 'No files added yet';
    const pending = droppedFiles.filter(function isPending(e) { return e.status === 'pending'; }).length;
    const parsed = droppedFiles.filter(function isParsed(e) { return e.status === 'parsed'; }).length;
    const unsupported = droppedFiles.filter(function isUnsupported(e) { return e.status === 'unsupported'; }).length;
    const detailParts = [];
    if (parsed > 0) detailParts.push(`${parsed} parsed`);
    if (pending > 0) detailParts.push(`${pending} pending`);
    if (unsupported > 0) detailParts.push(`${unsupported} unsupported`);
    const total = `${droppedFiles.length} file(s)`;
    return detailParts.length > 0 ? `${total} — ${detailParts.join(', ')}` : total;
}
